export default __webpack_public_path__ + "static/media/template5.b945e400.jpg";